import React, { useState, useEffect } from 'react';
import Form from '../../np-form/Form';
import { Dialog, withStyles } from '@material-ui/core';
import * as formUtility from '../../np-form/utility';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

const updateFirstFormState = props => {
    const { classes, customers } = props;

    // First form
    const firstForm = {
        Name: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'Name',
                label: 'Name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        LicenseNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'License number',
                label: 'License number',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        Payload: {
            elementType: 'input',
            elementConfig: {
                type: 'number',
                placeholder: 'Payload',
                label: 'Payload',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true,
                isNumeric: true
            },
            valid: false,
            touched: false
        },
        CustomerID: {
            elementType: 'select',
            elementConfig: {
                type: 'select',
                label: 'Customer',
                className: null,
                margin: "dense",
                fullWidth: true,
                options: customers ? [...customers] : []
            },
            formHelperText: "Please select customer",
            value: customers && customers.length > 0 ? customers[0].value : '',
            validation: {
                required: true
            },
            valid: true,
            touched: false
        }
    };
    return firstForm;
}

const VehicleCreate = props => {
    const { open, classes, activeCustomer } = props;

    const [vehicleForm, setVehicleForm] = useState(updateFirstFormState({ ...props }));
    const [vehicleFormValid, setVehicleFormValid] = useState(false);

    useEffect(() => {
        setVehicleForm(updateFirstFormState({ ...props }));
    }, [props]);

    const inputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, vehicleForm);
        setVehicleForm(updateState.myForm);
        setVehicleFormValid(updateState.formIsValid);
    };

    const submitHandler = event => {
        event.preventDefault();
        const formVehicle = formUtility.getFormData(vehicleForm);
        props.createVehicle({ ...formVehicle, ActiveCustomerID: activeCustomer });
        props.handleOpen();
        setVehicleForm(updateFirstFormState({}));
        setVehicleFormValid(false);
    };

    const cancelHandler = () => {
        setVehicleForm(updateFirstFormState({}));
        setVehicleFormValid(false);
        props.handleOpen();
    };

    return (
        <Dialog
            open={open}
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            disableEnforceFocus={true}
            fullWidth={true}
            onClose={cancelHandler}
        >
            <Form
                formIsValid={vehicleFormValid}
                classes={classes}
                form={vehicleForm}
                inputChangedHandler={inputChangedHandler}
                formTitle='Create Vehicle'
                buttonText='Submit'
                buttonTextCancel='Cancel'
                submitButtonStyle={{ borderRadius: '1px' }}
                submitHandler={submitHandler}
                cancelHandler={cancelHandler}
            />
        </Dialog>
    )
}
export default withStyles(styles, { withTheme: true })(VehicleCreate);